import { BooleanInput } from '@angular/cdk/coercion';
import {
  Component,
  HostBinding,
  ViewEncapsulation,
  booleanAttribute,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'procure-button-group',
  templateUrl: './button-group.component.html',
  styleUrl: './button-group.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class ButtonGroup {
  @HostBinding('class')
  get classes(): string {
    return ['button', this.filter() ? 'button--filter' : '']
      .filter(Boolean)
      .join(' ');
  }

  readonly filter = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });
}
